"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var _default = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, _constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED, false), (0, _defineProperty2.default)(_ref, _constants.FONT_FAMILY, 'helvetica'), (0, _defineProperty2.default)(_ref, _constants.LABEL_TEXT_COLOR, '#33475b'), (0, _defineProperty2.default)(_ref, _constants.LABEL_TEXT_SIZE, '13px'), (0, _defineProperty2.default)(_ref, _constants.SUBMIT_FONT_COLOR, '#ffffff'), (0, _defineProperty2.default)(_ref, _constants.SUBMIT_COLOR, '#ff7a59'), (0, _defineProperty2.default)(_ref, _constants.SUBMIT_ALIGNMENT, 'left'), _ref), _constants.FORM_SETTINGS);

exports.default = _default;
module.exports = exports.default;